module.exports = __webpack_public_path__ + "static/media/marker-s.7c27f18c.svg";